
/**
 * @typedef {import('../../../api-v2/js-doc').V2UpdateBrokerFactoringConfigRequest} V2UpdateBrokerFactoringConfigRequest
 * @typedef {import('../../../api-v2/js-doc').V1UpdateDebtorRequest} V1UpdateDebtorRequest
 */
export class DebtorMapper {

  /**
   * @param {V1UpdateDebtorRequest} v1Request - V1 create invoice request body
   * @returns {V2UpdateBrokerFactoringConfigRequest} - V2 create invoice request body
   */
  static v1UpdateBrokerRequestToV2 (v1Request) {
    return {
      __ingestThrough: true,
      __v1Payload: {},
      limitAmount: v1Request.debtor_limit,
      limitNote: v1Request.changelog_notes,
    }
  }
}

